import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...args) => twMerge(clsx(...args));

export const fmtTon = (n) =>
  Number(n || 0).toLocaleString("id-ID", { maximumFractionDigits: n < 100 ? 1 : 0 });

export const fmtNum = (n) => Number(n || 0).toLocaleString("id-ID");

export const fmtRp = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

export const pct = (a, b) => (b > 0 ? Math.round((a / b) * 100) : 0);
